/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
export var DeviceSetupPrepare = function DeviceSetupPrepare(_ref) {
  var connectBluetoothDevice = _ref.connectBluetoothDevice,
      handleStandardPlay = _ref.handleStandardPlay;
  return React.createElement("div", {
    className: "modal__device-setup__welcome"
  }, React.createElement("div", {
    className: "modal__device-setup__top"
  }, React.createElement(FormattedMessage, {
    id: "device.puton-header",
    defaultMessage: "Put on your heart rate monitor",
    tagName: "h3"
  }), React.createElement(FormattedMessage, {
    id: "device.place-header",
    defaultMessage: "Place the Wahoo TICKR directly on skin below your chest, or underneath your sports bra band.",
    tagName: "p"
  })), React.createElement("div", {
    className: "modal__device-setup__content"
  }, React.createElement("img", {
    src: require('../../../static/img/setup-monitor.svg'),
    alt: "Welcome",
    className: "modal__device-setup__device-img"
  }), React.createElement("button", {
    className: "bt bt--primary bt--width-md mv+",
    onClick: function onClick() {
      return connectBluetoothDevice();
    },
    key: "device.connect.button"
  }, React.createElement(FormattedMessage, {
    id: "modal.next",
    defaultMessage: "Next"
  })), React.createElement("p", null, React.createElement(FormattedMessage, {
    id: "device.footer",
    defaultMessage: "Don't have a heart rate monitor?",
    tagName: "span"
  }), React.createElement(Link, {
    onClick: function onClick() {
      return handleStandardPlay();
    },
    className: "ml-"
  }, React.createElement(FormattedMessage, {
    id: "device.video-only",
    defaultMessage: "Watch video only",
    tagName: "span"
  })))));
};
DeviceSetupPrepare.propTypes = {
  connectBluetoothDevice: PropTypes.func,
  handleStandardPlay: PropTypes.func
};